import React from "react";
import { MundoDePapelLanding } from "./pages/MundoDePapelLanding";
export function App() {
  return <MundoDePapelLanding data-id="element-0" data-mp="35ctsv9o847en" />;
}